import { Identifier, useDataProvider, useNotify } from "react-admin";
import { SiteResourcesEnum } from "shared/enums/resourceMappings";
import { useExport } from "shared/hooks/useExport";

export const useSiteExportButton = (siteId: Identifier) => {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const { handleExportJson } = useExport();

  const handleClick = async () => {
    try {
      const { data } = await dataProvider.getOne(SiteResourcesEnum.SiteExport, { id: siteId });
      if (!data) {
        throw new Error("Could not retrieve site data");
      }
      const documentTitle = `site-${siteId}-${data.name}-${process.env.REACT_APP_ENVIRONNEMENT}.json`;
      handleExportJson(data, documentTitle);
    } catch (error: any) {
      console.error("Error exporting site:", error);
      notify(`Error exporting site: ${error.message}`, { type: "error" });
    }
  };

  return { handleClick };
};
